// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__K_kBX"};
module.exports.__checksum = "a582f955d0a2"